import type { LucideIcon } from "lucide-react"

export interface InlineNavIconProps {
  filled?: boolean
  className?: string
}

export function createFilledIcon(Icon: LucideIcon) {
  function FilledIcon({ filled = false, className }: InlineNavIconProps) {
    return (
      <Icon
        className={className}
        fill={filled ? "currentColor" : "none"}
        strokeWidth={filled ? 0 : 2}
      />
    )
  }
  FilledIcon.displayName = `Filled(${Icon.displayName || "Icon"})`
  return FilledIcon
}

export function HomeNavIcon({ filled = false, className }: InlineNavIconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path
        d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z"
        fill={filled ? "currentColor" : "none"}
        stroke={filled ? "none" : "currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 22V12h6v10"
        fill="none"
        stroke={filled ? "currentColor" : "currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CreateNavIcon({
  filled = false,
  className,
}: InlineNavIconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <circle
        cx="12"
        cy="12"
        r="10"
        fill={filled ? "currentColor" : "none"}
        stroke={filled ? "none" : "currentColor"}
        strokeWidth="2"
      />
      <path
        d="M12 8v8M8 12h8"
        stroke={filled ? "black" : "currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}
